<template>
    <div class="event-card" v-on:click.prevent="$emit('clickSession', session)">
        <div class="event-card__title">
            {{ session.eventSessionTitle }}
        </div>
        <div class="event-card__time" v-html="getSessionDate(session)" v-on:click.stop="$emit('clickTimeslot', session)" v-if="dateLink"></div>
        <div class="event-card__time event-card__time--no-link" v-html="getSessionDate(session)" v-if="!dateLink"></div>
    </div>
</template>
<script>
    import axios from 'axios'
    import dateFormat from 'dateformat'
    import parseDate from 'parse-date'

    export default {

        props: {
            session: {
                default: null
            },
            dateLink: {
                default: true
            }
        },

        methods: {
            getOrangeDate: function(date) {
                var dateParts = date.split(" ");
                var dayParts = dateParts[0].split('-');
                var timeParts = dateParts[1].split(':');

                return new Date(dayParts[0], dayParts[1], dayParts[2], timeParts[0], timeParts[1], timeParts[2]);
            },

            getSessionDate: function(session) {
                var startDate = this.getOrangeDate(session.eventSessionStartDT);
                var endDate = this.getOrangeDate(session.eventSessionEndDT);

                return dateFormat(startDate, 'dddd, mmmm dS') + ' &bullet; ' + dateFormat(startDate, 'h:MMtt') + ' - ' + dateFormat(endDate, 'h:MMtt');
            }
        },

        created: function() {

        },

        watch: {

        }

    }
</script>


// WEBPACK FOOTER //
// SessionCard.vue?af6e2cc6